var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVirtualaccount1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2rem",
    height: "1.2rem",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5698ba",
    d: "M13.998 11.462q1.04 0 1.771-.729t.731-1.77t-.728-1.77t-1.77-.731t-1.771.728t-.731 1.77t.729 1.77t1.769.732m-5.421 4.48q1.067-1.151 2.47-1.777q1.401-.626 2.953-.626t2.954.626t2.469 1.777q.25 0 .414-.182q.163-.183.163-.433V4.616q0-.27-.173-.443T19.385 4H8.615q-.269 0-.442.173T8 4.616v10.711q0 .25.164.433q.163.182.413.182M8.616 17q-.667 0-1.141-.475T7 15.386V4.615q0-.666.475-1.14T8.615 3h10.77q.666 0 1.14.475T21 4.615v10.77q0 .666-.475 1.14t-1.14.475zm-4 4q-.667 0-1.141-.475T3 19.386V7.5q0-.213.144-.356T3.501 7t.356.144T4 7.5v11.885q0 .269.173.442t.443.173H16.5q.213 0 .356.144t.144.357t-.144.356T16.5 21zM14 10.462q-.617 0-1.059-.442q-.441-.441-.441-1.059t.441-1.058q.442-.442 1.059-.442t1.059.442t.441 1.058t-.441 1.06q-.442.44-1.059.44M9.97 16h8.06q-.84-.73-1.872-1.096T14 14.538t-2.158.366T9.97 16M14 9.971"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtualaccount1);
export default __webpack_public_path__ + "static/media/virtualaccount1.bcd1e8e5bbaba13b75de6b26ea9e076a.svg";
export { ForwardRef as ReactComponent };